"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IframeResizerContext: function() {
        return IframeResizerContext;
    },
    IframeResizerProvider: function() {
        return IframeResizerProvider;
    },
    defaultIframePageInfo: function() {
        return defaultIframePageInfo;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const defaultIframePageInfo = {
    iframeHeight: 0,
    iframeWidth: 0,
    offsetLeft: 0,
    offsetTop: 0,
    scrollLeft: 0,
    scrollTop: 0,
    clientHeight: 0,
    clientWidth: 0
};
const IframeResizerContext = /*#__PURE__*/ (0, _react.createContext)({
    inIframe: false,
    pageInfo: defaultIframePageInfo,
    heightCalculationMethod: "bodyOffset",
    size: ()=>undefined,
    setHeightCalculationMethod: ()=>undefined
});
const IframeResizerProvider = (param)=>{
    let { children, parentIFrame } = param;
    const [minIframeHeight, setMinIframeHeight] = (0, _react.useState)();
    const [iframePageInfo, setIframePageInfo] = (0, _react.useState)(defaultIframePageInfo);
    const [heightMethod, setHeightMethod] = (0, _react.useState)("bodyOffset");
    (0, _react.useEffect)(()=>{
        if (parentIFrame != null) {
            parentIFrame.getPageInfo(setIframePageInfo);
        }
    }, [
        parentIFrame
    ]);
    (0, _react.useEffect)(()=>{
        const listener = (e)=>{
            if (typeof e.data === "string" && e.data.startsWith("EquiemMinIframeHeight:")) {
                setMinIframeHeight(parseInt(e.data.replace("EquiemMinIframeHeight:", ""), 10));
            }
        };
        window.addEventListener("message", listener);
        return ()=>{
            window.removeEventListener("message", listener);
        };
    }, []);
    const size = (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        parentIFrame === null || parentIFrame === void 0 ? void 0 : parentIFrame.size(...args);
    }, [
        parentIFrame
    ]);
    const setHeightCalculationMethod = (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setHeightMethod(args[0]);
        parentIFrame === null || parentIFrame === void 0 ? void 0 : parentIFrame.setHeightCalculationMethod(...args);
    }, [
        parentIFrame
    ]);
    return /*#__PURE__*/ _react.default.createElement(IframeResizerContext.Provider, {
        value: {
            inIframe: window.parentIFrame != null,
            pageInfo: iframePageInfo,
            size,
            heightCalculationMethod: heightMethod,
            setHeightCalculationMethod,
            minIframeHeight
        }
    }, children);
};

//# sourceMappingURL=IframePageInfoContext.js.map